/*
 * File: make-validator.ts
 * File Created: 2024-09-26 10:56:45
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-26 01:05:38
 * Modified By: Val Liu
 * -----
 */

import {
    ICreateRequiredValidatorOption,
    ICreateValidatorOption,
    createRequiredValidator,
    createValidator,
} from "@root/components/form/core/lib/core";

export function makeRequiredValidator(option: ICreateRequiredValidatorOption) {
    let func: any;
    return function (target: any, propertyKey: string, descriptor: PropertyDescriptor) {
        descriptor.value = function (o) {
            func ??= createRequiredValidator({
                ...option,
                validator: (o) => option.validator.call(this, o),
            });
            return func(o);
        };
        return descriptor;
    };
}

export function makeValidator(option: ICreateValidatorOption) {
    let func: any;
    return function (target: any, propertyKey: string, descriptor: PropertyDescriptor) {
        descriptor.value = function (o) {
            const { validator, message, success } = option;
            func ??= createValidator({
                validator: (o) => validator.call(this, o),
                message: typeof message === "function" ? message.call(this, o) : message,
                success: typeof success === "function" ? success.call(this, o) : success,
            });
            return func(o);
        };
        return descriptor;
    };
}
